import * as React from 'react';

import * as styles from './undergroundList.css';

export const UndergroundList = (props: React.PropsWithChildren<{}>) => {
  return <ul className={styles['undergrounds']}>{props.children}</ul>;
};
